import TimelapseRoundedIcon from '@mui/icons-material/TimelapseRounded';
import React from 'react';
import { useTranslation } from '@corti/i18n';
import { Tooltip } from 'lib/cortiUI';
export const PendingAiScoreIndicator = () => {
    const { t } = useTranslation('missionControlApp', { keyPrefix: 'callsDataGrid' });
    return (React.createElement(Tooltip, { title: t('pendingAiScoreTooltip', 'AI Score for this call will be available shortly.') },
        React.createElement(TimelapseRoundedIcon, { fontSize: "small", color: "action" })));
};
